import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { SensorCableSlotExcelStyle } from 'icreate/common/models/sensor-cable-tag';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SensorCableSheetStylesApiService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getSlotStyle(slotId: string, outputSelector?): Promise<SensorCableSlotExcelStyle> {
        return await lastValueFrom(
            this.http.get<SensorCableSlotExcelStyle>(`${this.domain}/api/sensor-cable-style`, {
                params: { slotId, outputSelector },
            })
        );
    }

    async updateSlotStyle(slotStyles: SensorCableSlotExcelStyle): Promise<SensorCableSlotExcelStyle> {
        return await lastValueFrom(
            this.http.put<SensorCableSlotExcelStyle>(`${this.domain}/api/sensor-cable-style`, slotStyles, {
                headers: this.headers,
            })
        );
    }
}
